import styled, { DefaultTheme } from 'styled-components';

type RadioButtonColor = 'primary' | 'secondary';

const getActiveColor = (color: RadioButtonColor, theme: DefaultTheme) => {
  if (color === 'secondary') return theme.palette.system.blue;
  return theme.palette.brand.main;
};

export const RadioButton = styled.div<{
  $isActive: boolean;
  $color?: RadioButtonColor;
}>`
  position: relative;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border: 1px solid
    ${({ theme, $isActive, $color = 'primary' }) =>
      $isActive
        ? getActiveColor($color, theme)
        : theme.palette.secondary.border};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.system.white};

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background-color: ${({ theme, $color = 'primary' }) =>
      getActiveColor($color, theme)};
    opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};
    display: ${({ $isActive }) => ($isActive ? 'block' : 'none')};
  }
`;
